import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "17",
  fill: "none",
  viewBox: "0 0 18 17"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#333",
      d: "m3.072.36 6.233 6.233L15.538.379a1.26 1.26 0 0 1 .944-.378 1.42 1.42 0 0 1 1.323 1.322 1.25 1.25 0 0 1-.378.907L11.175 8.5l6.252 6.27c.245.239.381.567.378.907A1.416 1.416 0 0 1 16.482 17a1.27 1.27 0 0 1-.944-.377l-6.233-6.214-6.214 6.214a1.27 1.27 0 0 1-.945.377 1.416 1.416 0 0 1-1.34-1.34 1.25 1.25 0 0 1 .377-.907L7.435 8.5 1.164 2.23a1.25 1.25 0 0 1-.359-.907A1.416 1.416 0 0 1 2.127.001a1.27 1.27 0 0 1 .945.36"
    }, null, -1)
  ])))
}
export default { render: render }